import workspaceQuery from 'graphql/queries/vat/VatBusinessCategoryWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/vat/VatBusinessCategoryListQuery.graphql';
import instanceQuery from 'graphql/queries/vat/VatBusinessCategoryQuery.graphql';
import defaultQuery from 'graphql/queries/vat/VatBusinessCategoryDefault.graphql';
import mutationQuery from 'graphql/mutations/vat/VatBusinessCategoryMutation.graphql';
import fragment from 'graphql/fragments/vat/VatBusinessCategoryFragment.graphql';

const VatBusinessCategory = {
  type: 'VatBusinessCategory',
  title: 'Business VAT Status',
  formTitle: 'Business VAT Status',
  formUrl: '/Vat/BusinessStatus/Details/',
  workspaceUrl: '/Vat/BusinessStatus/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'VAT_BUSINESS_CATEGORIES',
};

export default VatBusinessCategory;
